<template>
<div class="wlt-down-load-wrapper">
    <div class="tab-main-con">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="物流管理" name="1">
                <h1 class="down-load-h1">物流考试软件下载</h1>
                <div class="down-main-con clearfix">
                    <div>
                        <table class="download-table-con" border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="td-1">分类</td>
                                <td>软件</td>
                                <td>说明</td>
                                <td class="down-td-con">软件下载</td>
                                <td class="down-td-con">操作文档下载</td>
                            </tr>
                            <tr>
                                <td rowspan="2">1.实务考核</td>
                            </tr>
                            <tr>
                                <td>
                                    <p>学生端</p>
                                </td>
                                <td>
                                    <p>安装在考场的学生电脑上</p>
                                </td>
                                <td class="down-td-con">
                                    <a :href="form.XSDUrl">
                                        <i class="el-icon-download"> </i>下载
                                    </a>
                                </td>
                                <td class="down-td-con">
                                    <a :href="form.XSDWDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2.实操考核</td>
                                <td>手持终端软件</td>
                                <td>安装在手持终端上</td>
                                <td class="down-td-con">
                                    <a :href="form.SCDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>

                                </td>
                                <td class="down-td-con">
                                    <a :href="form.SCDWDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                    <a href="javascript:void(0);" @click="seeVideo">查看安装视频
                                    </a>
                                </td>
                            </tr>
                        </table>
                        <h1 class="down-load-h1">物流考试相关文件下载</h1>
                        <table class="download-table-con" border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="td-1" width="100px">序号</td>
                                <td>文件名称</td>
                                <td width="160px">下载</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>物流管理职业技能等级证书考务手册</td>
                                <td class="down-td-con">
                                    <a :href="form.GLGFUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td>2</td>
                                <td>职业技能等级证书信息管理平台-考试报名流程及规范.pdf</td>
                                <td class="down-td-con">
                                    <a :href="form.LCTUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr> -->
                            <tr>
                                <td>2</td>
                                <td>标识牌、工牌文件</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/4b2kaocod71etmbe7h4mja/BQCQhmWiJTjQHJX4.rar?response-content-disposition=attachment;filename=标识牌及胸牌.rar">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>巡考记录表、考场情况记录表</td>
                                <td class="down-td-con">
                                    <a :href="form.GLDWDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>考评员评分表</td>
                                <td class="down-td-con">
                                    <a :href="form.GLDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>物流管理职业技能等级证书签发流程</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/4b2kaocod71etmbe7h4mja/YyftaPabzSYMnhcZ.docx?response-content-disposition=attachment;filename=物流管理职业技能等级证书签发流程20210201.docx">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>考场纪律表</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/xdmyaeaq8ojo0nkhmu8ada/3ny3Zw4atBahbdaR.docx?response-content-disposition=attachment;filename=考场纪律表.docx">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                        </table>
                        <h1 class="down-load-h1">物流考试声明文件</h1>
                        <table class="download-table-con" border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="td-1" width="100px">序号</td>
                                <td>文件名称</td>
                                <td width="160px">查看</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>各院校声明函 20191120-v2.pdf</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/66ykt/ori/qagzal6ooltkgnilzlcx4q/nPM2Dc3R8Gn2BQeb.pdf" download="各院校声明函 20191120-v2.pdf">
                                        <i class="el-icon-view"></i>查看
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>证书制度试点声明20201105-V3.pdf</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/qagzal6ooltkgnilzlcx4q/EDtpnC6T58xSy7PN.pdf" download="证书制度试点声明20201105-V3.pdf">
                                        <i class="el-icon-view"></i>查看
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="供应链运营" name="2">
                <!-- <div class="chain-run-con">
                    <div class="no-data-con">
                        <img :src="noDataImg" alt="">
                    </div>
                </div> -->
                 <div class="down-main-con clearfix">
                        <h1 class="down-load-h1">供应链考试软件下载</h1>
                    <div>
                        <table class="download-table-con" border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="td-1">分类</td>
                                <td>软件</td>
                                <td>说明</td>
                                <td class="down-td-con">软件下载</td>
                                <td class="down-td-con">操作文档下载</td>
                            </tr>
                            <tr>
                                <td rowspan="2">1.考核系统</td>
                            </tr>
                            <tr>
                                <td>
                                    <p>学生端</p>
                                </td>
                                <td>
                                    <p>安装在考场的学生电脑上</p>
                                </td>
                                <td class="down-td-con">
                                    <a :href="form.XSDUrl">
                                        <i class="el-icon-download"> </i>下载
                                    </a>
                                </td>
                                <td class="down-td-con">
                                    <a :href="form.XSDWDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                        </table>

                        <h1 class="down-load-h1">供应链运营考试相关文件下载</h1>
                        <table class="download-table-con" border="0" cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="td-1" width="100px">序号</td>
                                <td>文件名称</td>
                                <td width="160px">下载</td>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>供应链运营职业技能等级证书考务手册</td>
                                <td class="down-td-con">
                                    <a :href="form.GLGFUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>标识牌、工牌文件</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/pzuvaesrpafgwt3kofbgag/Y2XQiiDRh43fFyte.zip?response-content-disposition=attachment;filename=供应链运营考试工牌、标识牌文件.zip">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>巡考情况记录表</td>
                                <td class="down-td-con">
                                    <a :href="form.GLDWDUrl">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>供应链运营考场情况记录表</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/seiwar2qh5tm31taautdra/trPkZAxHJs7mmXfw.docx?response-content-disposition=attachment;filename=供应链运营考场情况记录表.docx">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>5</td>
                                <td>供应链运营职业技能等级证书考试签到表</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/seiwar2qh5tm31taautdra/ez5D73AjMZd4A5ij.docx?response-content-disposition=attachment;filename=供应链运营职业技能等级证书考试签到表.docx">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>6</td>
                                <td>考场纪律表</td>
                                <td class="down-td-con">
                                    <a href="https://file.clpp.org.cn/ykt/ori/xdmyaeaq8ojo0nkhmu8ada/3ny3Zw4atBahbdaR.docx?response-content-disposition=attachment;filename=考场纪律表.docx">
                                        <i class="el-icon-download"></i>下载
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </div>
                 </div>
            </el-tab-pane>
        </el-tabs>
    </div>

    <el-dialog title="安装视频" :visible.sync="dialogVisible" width="900px" @close="closeVideo">
        <div class="install-video-con">
            <video controls ref="installVideo">
                <source src="https://file.clpp.org.cn/66ykt/ori/9ukjaqepw4hgmisc4uis1q/7zajaw3Qn4feXcWW.mp4" />
            </video>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeVideo">关闭</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    props:{
        type:{
            type: [String,Number],
            default:""
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {
                KWDUrl: "",
                KWWDUrl: "",
                GLDUrl: "",
                GLDWDUrl: "",
                XSDUrl: "",
                XSDWDUrl: "",
                SCDUrl: "",
                SCDWDUrl: "",
                GLGFUrl: "",
                LCTUrl: ""
            },
            activeName: '1',
            noDataImg: require('assets/images/the-last-new-nodata-imag.png')
        };
    },
    created() {
        this.activeName = String(this.type);
        this.getFileUrlList();
    },
    watch:{
        $route(){
            this.activeName = String(this.type);
        },
    },
    methods: {
        handleClick(tab, event){
            this.activeName = String(tab.name);
            this.getFileUrlList();
        },
        //查询
        getFileUrlList() {
            var that = this;
            var certificateId = '';
            if(this.activeName=='1'){
                certificateId = "dnmeaa2seqbkn9fqiaawfq"
            }else{
                certificateId = "0j6eacat97rafjaiqtfazg"
            }

            this.$http
                .post("/api/XOrg/FileManager/getFileUrlList", {
                    certificateId: certificateId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.form = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getOnlineHelp() {
            this.$router.push({
                name: "linkCompany"
            });
        },
        seeVideo() {
            this.dialogVisible = true;
        },
        closeVideo() {
            this.dialogVisible = false;
            this.$refs.installVideo.pause();
        }
    }
};
</script>

<style lang="scss">
@import "~theme/mixin/mixins.scss";

.wlt-down-load-wrapper {
    padding-bottom: 30px;

    .tab-main-con {
        margin: 0 auto;
        width: 1200px;

        .el-tabs__nav {
            float: none;
            margin: 0 auto;
            width: 247px;
        }

        .el-tabs__item {
            font-size: 23px;
        }

        .chain-run-con {
            margin: 0 auto;
            width: 1200px;
        }

        .no-data-con {
            margin-top: 60px;
            text-align: center;
        }
    }

    .install-video-con {
        height: 500px;

        video {
            width: 100%;
        }
    }

    .down-load-h1 {
        margin: 8px 0;
        text-align: center;
        color: #49a4fc;
        font-size: 22px;
        font-weight: 400;
    }

    .a-top-link {
        display: block;
        margin-bottom: 20px;
        color: #F56C6C;
        font-size: 20px;
    }

    .down-main-con {

        .p-title-1 {
            color: #5fc4fd;
            font-size: 40px;
        }

        .down-cell-li {
            position: relative;
            margin: 30px 20px 0 0;
            padding: 0 10px;
            border-radius: 30px;
            border: 1px solid #49a4fc;
            @include word-size(50px, center, 18px, #49a4fc, #fff);
        }

        .download-table-con {
            margin-top: 15px;
            width: 100%;
        }

        .download-table-con {
            border-right: 1px solid #7ebdfd;
            border-bottom: 1px solid #7ebdfd;

            td {
                padding: 7px 10px;
                border-left: 1px solid #7ebdfd;
                border-top: 1px solid #7ebdfd;
            }

            .down-td-con {
                text-align: center;

                a {
                    display: inline-block;
                    vertical-align: top;
                    padding: 0 10px;
                    border-radius: 4px;
                    margin-right: 10px;
                    @include word-size(27px, center, 14px, #fff, #49a4fc);
                }
            }
        }

        .line-help-link {
            margin-top: 40px;
            background: linear-gradient(-45deg, #4aa4fc, #9cd5fe);
            border: none;
            color: #fff;
        }

        .see-video-btn {
            margin-top: 36px;
        }
    }

    .p-download-title {
        margin-top: 20px;
    }

    .p-download-link-li {
        margin-top: 15px;
        color: #F56C6C;

        a {
            color: #F56C6C;
        }
    }

    .link-company-person {
        margin-top: 10px;
        color: #5fc4fd;
        font-size: 22px;

        .P-link-1,
        .P-link-2 {
            padding-left: 5px;
            border-left: 2px solid #5fc4fd;
            line-height: 1;
        }

        .P-link-1 {
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .sp-qw-link {
            margin-left: 22px;
        }

        .P-link-3 {
            margin: 15px 0 0 125px;
        }

        .P-link-2 {
            margin-top: 30px;
        }
    }
}

@media only screen and (max-width:1366px) {
    .wlt-down-load-wrapper {
        .down-head-con {
            padding-top: 25px;
        }

        .down-main-con {
            margin: 35px auto 0;

            .p-title-1 {
                font-size: 40px;
            }

            .download-table-con {
                margin-top: 30px;
            }

            .link-company-person {
                margin-top: 30px;
            }
        }
    }
}
</style>
